module.exports = __webpack_public_path__ + "static/media/23.9fb909b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/23.png
// module id = 594
// module chunks = 0